import { MEMBER_ID, ORG_ID, StringTMap } from '@@types/common';
import { Organization } from '@@types/Organization';

import { lift } from '~/utils/monadUtil';
import { isEmpty } from 'lodash';
import { action, observable } from 'mobx';
import { concat, curry, identity, pipe, prop } from 'ramda';
import { Maybe } from 'ramda-fantasy';

class OrgsStore {
  @observable
  orgMap: StringTMap<Organization> = {};

  @observable
  isLoading = {};

  getById = (orgId: string): Maybe<Organization> => {
    return pipe<any, any, any>(prop(orgId), lift(identity))(this.orgMap);
  };

  @action
  concatMembers = (orgId: ORG_ID, membersId: MEMBER_ID[]) => {
    if (isEmpty(this.orgMap[orgId].members)) {
      this.orgMap[orgId].members = membersId;
    } else {
      this.orgMap[orgId].members = pipe<any, any>(concat(this.orgMap[orgId].members))(membersId);
    }
  };

  @action
  setIsLoading = curry((orgId, value) => {
    this.isLoading[orgId] = value;
  });

  @action
  setOrg = (org) => {
    this.orgMap[org.id] = org;
  };

  @action
  setPage = curry((orgId, page) => {
    this.orgMap[orgId].page = page;
  });
}

export default OrgsStore;

export const orgsStore = new OrgsStore();
